export default "__VITE_ASSET__CyS_SYe7__"